import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Notifications_ModuleContextService } from './Notifications.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Notifications_auto_email_field_parameters_by_entity_grid_ComponentContextService {
  private readonly moduleContext: Notifications_ModuleContextService;

  constructor(moduleContext: Notifications_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'auto_email_field_parameters_by_entity_grid',
      type: ComponentType.grid
    }
  }
}